import axios from 'axios';

let globalRequestId = 1;

export default function createApi({ apiUrl, log, cookie = null }) {
  const baseConfig = {
    withCredentials: true,
  };

  if (cookie) {
    baseConfig.headers = baseConfig.headers || {};
    baseConfig.headers.Cookie = cookie;
  }

  function request(url, reqConfig) {
    const requestId = globalRequestId++;

    reqConfig = { withBaseUrl: true, ...reqConfig };

    log.debug(
      `[R${requestId}]: ${reqConfig.method || 'GET'} ${url}`,
      reqConfig.data,
    );

    return axios
      .request({
        ...baseConfig,
        ...reqConfig,
        url: reqConfig.withBaseUrl ? `${apiUrl}${url}` : `${url}`,
      })
      .then(
        response => {
          log.debug(
            `... [R${requestId}]: ${response.status} ${response.statusText} = `,
            response.data,
          );
          return response;
        },
        error => {
          log.warn(`... [R${requestId}]: error: `, error);
          throw error;
        },
      );
  }

  return {
    request,
  };
}
